const isDevelopment = process.env.NODE_ENV === 'development';

const isLocalHost = 
  typeof window !== 'undefined' && 
  (window.location.hostname === 'localhost' || 
   window.location.hostname === '127.0.0.1' ||
   window.location.hostname === '');

export const API_URLS = {
  local: 'http://localhost:5001',
  production: 'https://engineeringofstockbackend.onrender.com',
  
  get current() {
    if (process.env.REACT_APP_API_URL) {
      return process.env.REACT_APP_API_URL;
    }
    
    if (isLocalHost || isDevelopment) {
      return this.local;
    }
    
    return this.production;
  }
};

export const getApiUrl = (endpoint) => {
  const baseUrl = API_URLS.current;
  const path = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${baseUrl}${path}`;
};

export const isLocalApi = () => {
  return API_URLS.current === API_URLS.local;
};

export const isProductionApi = () => {
  return API_URLS.current === API_URLS.production;
};

export default API_URLS;

